import * as React from 'react';

const TickIcon = ({fillColor = '#fff'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20}>
    <path
      fill={fillColor}
      d="M9.375 16.7917V10.3542L3.75 7.10419V13.5417L9.375 16.7917ZM10.625 16.7917L16.25 13.5417V7.08335L10.625 10.3508V16.7917ZM10 9.29169L15.5417 6.06252L10 2.85419L4.4375 6.06252L10 9.29169ZM3.125 14.625C2.92708 14.508 2.77344 14.3537 2.66406 14.1622C2.55469 13.9708 2.5 13.7639 2.5 13.5417V6.45835C2.5 6.23613 2.55469 6.02928 2.66406 5.83779C2.77344 5.64631 2.92708 5.49205 3.125 5.37502L9.375 1.77085C9.574 1.65974 9.78347 1.60419 10.0034 1.60419C10.2234 1.60419 10.4306 1.65974 10.625 1.77085L16.875 5.37502C17.0729 5.49205 17.2266 5.64631 17.3359 5.83779C17.4453 6.02928 17.5 6.23613 17.5 6.45835V13.5417C17.5 13.7639 17.4453 13.9708 17.3359 14.1622C17.2266 14.3537 17.0729 14.508 16.875 14.625L10.625 18.2292C10.426 18.3403 10.2165 18.3959 9.99658 18.3959C9.77664 18.3959 9.56944 18.3403 9.375 18.2292L3.125 14.625Z"
    />
  </svg>
);

export default TickIcon;
